import { ActionStatusTypes, IBadgeData } from "../../types/interfaces";

export enum PublicBadgeActionsTypes {
  GET_BADGE_DATA = "publicBadge/get_data",
  GET_BADGE_DATA_SUCCESS = "publicBadge/get_data_success",
  GET_BADGE_DATA_FAILED = "publicBadge/get_data_failed",
  CLEAN_BADGE_DATA = "publicBadge/clean_data",
}

export interface IGetBadgeData {
  type: PublicBadgeActionsTypes.GET_BADGE_DATA;
  payload: {
    badgeId: string;
  };
}

export interface IGetBadgeDataSuccess {
  type: PublicBadgeActionsTypes.GET_BADGE_DATA_SUCCESS;
  payload: {
    badgeData: IBadgeData;
  };
}

export interface IGetBadgeDataFailed {
  type: PublicBadgeActionsTypes.GET_BADGE_DATA_FAILED;
}

export interface ICleanBadgeData {
  type: PublicBadgeActionsTypes.CLEAN_BADGE_DATA;
}

export type PublicBadgeActions =
  | IGetBadgeData
  | IGetBadgeDataSuccess
  | IGetBadgeDataFailed
  | ICleanBadgeData;

export interface IScafoldingState {
  badgeData?: IBadgeData;
  loadBadgeDataStatus?: ActionStatusTypes;
}
